export default function FeatureCard({ icon: Icon, title, description }) {
  return (
    <div className="group relative bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-slate-200 dark:border-slate-700">
      <div className="absolute inset-0 bg-gradient-to-br from-sky-500/5 to-blue-500/5 dark:from-sky-400/10 dark:to-blue-400/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      <div className="relative">
        <div className="mb-4 inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br from-sky-500 to-blue-600 dark:from-sky-400 dark:to-blue-500 rounded-xl shadow-lg">
          <Icon className="w-7 h-7 text-white" strokeWidth={2.5} />
        </div>
        <h3 className="text-xl font-bold mb-3 text-slate-900 dark:text-white">{title}</h3>
        <p className="text-slate-600 dark:text-slate-300 leading-relaxed">{description}</p>
      </div>
    </div>
  );
}
